import Button from "@ds/components/Button";
import Text from "@ds/components/Text";
import useResponsive from "@helpers/useResponsive";
import { Box, Link } from "@mui/material";
import IconCheck from "@mui/icons-material/Check";
import { useTranslation, withTranslation } from "next-i18next";
import ConsentDetail from "./ConsentDetail";
import useAction from "./hooks/useAction";

const CookiesConsent: React.FC = () => {
  const { t } = useTranslation('cookies');
  const isMobile = useResponsive('md');

  const { show, isOpenDetail, onClickConsent, toggleDetail } = useAction();

  return (
    <Box
      position="fixed"
      padding={3}
      bgcolor="background.paper"
      borderRadius={2}
      boxShadow={3}
      zIndex={999}
      bottom="-1000px"
      right="40px"
      maxWidth="400px"
      sx={{
        transition: 'bottom 0.3s ease-in-out',
      }}
      {...show && {
        bottom: isMobile ? '16px' : '40px',
      }}
      {...isMobile && {
        maxWidth: '100%',
        width: 'calc(100% - 32px)',
        left: '16px',
        right: '16px',
      }}
    >
      <Text variant="h3" weight="700">{t('title')}</Text>
      <Box marginTop={2} marginBottom={3}>
        <Text paragraph variant="caption1" sx={{ marginBottom: '16px' }}>{t('body.text1')}</Text>
        <Text paragraph variant="caption1">{t('body.text2')}</Text>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Button size="medium" fullWidth onClick={() => onClickConsent(true)}>
          {t('button.acceptAll')}
          <IconCheck sx={{ marginLeft: '8px' }} />
        </Button>
        <Button variant="outlined" size="medium" fullWidth onClick={() => onClickConsent(false)} sx={{
          marginY: '16px'
        }}>
          {t('button.acceptNecessary')}
        </Button>
        <Text variant="caption1">
          {t('footnote.text')}&nbsp;
          <Link
            fontSize="12px"
            onClick={toggleDetail}
            sx={{ cursor: 'pointer' }}
            variant="body2"
          >
            {t('footnote.button')}
          </Link>
          .
        </Text>
      </Box>
      <ConsentDetail
        isOpen={isOpenDetail}
        onClose={toggleDetail}
        onClickAcceptAll={() => onClickConsent(true)}
        onClickAcceptNecessary={() => onClickConsent(false)}
      />
    </Box>
  );
};

export default withTranslation(['cookies'])(CookiesConsent);
